import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '../common/utils/classnames';
import { transformInterval } from '../common/utils';
import { useMobile } from '../common/hooks/use-mobile';
/**
 * 商品卡
 * mob端:横向滚动
 */
export var RollContent = function RollContent(_ref) {
  var GoodsCardComponent = _ref.GoodsCardComponent,
    displaySaleProducts = _ref.displaySaleProducts,
    addCart = _ref.addCart,
    collect = _ref.collect,
    goodsGap = _ref.goodsGap;
  var mobile = useMobile();
  return _jsx("main", Object.assign({
    className: classNames('flex flex-nowrap overflow-x-scroll hide-scrollbar', 'cq-pc:grid cq-pc:grid-cols-6'),
    style: {
      marginLeft: mobile ? "-".concat(transformInterval(goodsGap, mobile, 'proudcCard')) : 0,
      gap: mobile ? 0 : transformInterval(goodsGap, mobile, 'proudcCard')
    }
  }, {
    children: displaySaleProducts.map(function (item) {
      return _jsx(GoodsCardComponent, {
        className: classNames('flex-shrink-0 w-47', 'cq-pc:col-span-1 cq-pc:w-auto'),
        style: {
          marginLeft: mobile ? transformInterval(goodsGap, mobile, 'proudcCard') : 0
        },
        goods: item,
        enableSale: false,
        saleLeftTime: +new Date(item.seckillEndTime) - Date.now(),
        onAddCart: addCart,
        onCollect: collect
      }, item.csku);
    })
  }));
};